import apiService from '@sonifi/wb-core/services/api.service';
import { setHomeImages } from '@sonifi/wb-home/store/homeSlice';
import { ENDPOINTS } from '@sonifi/wb-core/services/endpointsConstants';

export const getHomeImages = () => async (dispatch, getState) => {
  try {
    const imagesRes = await apiService.get(ENDPOINTS.MARKETING_IMAGES);
    const {
      user: { authenticated },
    } = getState();
    dispatch(setHomeImages({ images: imagesRes.data.objects, authenticated }));
  } catch (error) {
    console.error(error);
  }
};
